import Box from "./Box";
import BoxWithGutter from "./BoxWithGutter";
import LargeLink from "./LargeLink";
import ProductGrid from "./ProductGrid";
import PropTypes from "prop-types";
import React from "react";

function CategoryPromo({ category, brand }) {
  const href = brand
    ? `/${brand.slug}/${category.rootCategorySlug}`
    : `/${category.rootCategorySlug}`;
  return (
    <Box my={[32, null, 80, null]}>
      <BoxWithGutter>
        <Box mb={[23, null, 50, null]}>
          <LargeLink text={category.title} href={href} />
        </Box>
        <ProductGrid
          products={category.products}
          brand={brand}
          desktopCols={4}
          mobCols={2}
          showCondition
        />
      </BoxWithGutter>
    </Box>
  );
}

export default CategoryPromo;

CategoryPromo.propTypes = {
  category: PropTypes.shape({
    title: PropTypes.string.isRequired,
    products: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
};
